<template>
  <v-navigation-drawer app dark expand-on-hover class="hidden-sm-only d-flex">
    <v-list-item>
      <v-list-item-action>
        <v-icon>mdi-motion-sensor</v-icon>
      </v-list-item-action>
      <v-list-item-content>
        <v-list-item-title class="title">BDOTRACKER</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list dense>
      <v-list-item router to="/">
        <v-list-item-action>
          <v-icon>mdi-home</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Home</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item router to="/character/warflash">
        <v-list-item-action>
          <v-icon>mdi-account</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>User</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item router to="/guilds/clarity">
        <v-list-item-action>
          <v-icon>mdi-shield</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Guilds</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item router to="/leaderboards">
        <v-list-item-action>
          <v-icon>mdi-trophy</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Leaderboards</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item router to="/timers">
        <v-list-item-action>
          <v-icon>mdi-timer-sand</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>Timers</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "Sidebar"
};
</script>